<template>
  <div class="hidden md:flex md:flex-1">
    <template v-for="item in menuItems">
      <router-link
        v-if="item.routeName"
        :key="item.routeName"
        :to="item.routeName"
        tag="div"
        class="mr-8 border-orange flex items-center text-grey relative"
        active-class="custom-after"
      >
        <a class="cursor-pointer font-roman text-sm">
          {{ item.title }}
        </a>
      </router-link>
      <div
        v-else
        :key="item.href"
        class="mr-8 border-orange flex items-center text-grey relative"
      >
        <a
          :href="item.href"
          class="cursor-pointer font-roman text-sm"
          target="_blank"
        >
          {{ item.title }}
        </a>
      </div>
    </template>
  </div>
</template>

<script>
import { MENU_ITEMS } from '../constants';

export default {
  name: 'TheNavbar',
  props: {
    rightItem: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      menuItems: MENU_ITEMS,
    };
  },
};
</script>

<style lang="scss" scoped>
.custom-after {
  &::after {
    content: ' ';
    position: absolute;
    height: 1px;
    background: red;
    width: 100%;
    bottom: calc(-16px - 1px);
  }
}
</style>
